import React, { createContext, useContext, useState } from 'react';

interface ChatWidgetContextType {
  isChatWidgetOpen: boolean;
  openChatWidget: () => void;
  closeChatWidget: () => void;
}

const ChatWidgetContext = createContext<ChatWidgetContextType | undefined>(
  undefined
);

export const ChatWidgetProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isChatWidgetOpen, setIsChatWidgetOpen] = useState(false);

  const openChatWidget = () => setIsChatWidgetOpen(true);
  const closeChatWidget = () => setIsChatWidgetOpen(false);

  return (
    <ChatWidgetContext.Provider
      value={{ isChatWidgetOpen, openChatWidget, closeChatWidget }}
    >
      {children}
    </ChatWidgetContext.Provider>
  );
};

export const useChatWidget = () => {
  const context = useContext(ChatWidgetContext);
  if (context === undefined) {
    throw new Error('useChatWidget must be used within a ChatWidgetProvider');
  }
  return context;
};
